import * as XLSX from 'xlsx';

// Должно совпадать с бэкендом (app/core/config.py). Фронт даёт мгновенную
// обратную связь и не грузит гигантские файлы на сервер; бэк — реальный гейт.
export const MAX_UPLOAD_MB = 25;
export const MAX_REQUEST_ROWS = 3000;
export const MAX_PRICE_ROWS = 60000;
export const MAX_REQUEST_FILES = 50;

/** Что вообще принимаем в заявке. Прайс — по-прежнему только таблицы. */
export const REQUEST_EXTENSIONS = [
  '.xlsx', '.xls', '.csv', '.pdf', '.docx',
  '.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif', '.bmp', '.tif', '.tiff',
];

/** accept для react-dropzone: заявка. */
export const REQUEST_ACCEPT: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'text/csv': ['.csv'],
  'image/*': ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif', '.bmp', '.tif', '.tiff'],
};

function hasExtension(name: string, extensions: string[]): boolean {
  const lower = name.toLowerCase();
  return extensions.some(ext => lower.endsWith(ext));
}

/**
 * Проверяет файл перед загрузкой.
 * @returns строку с ошибкой, если файл не проходит, иначе null.
 */
export async function validateUploadFile(
  file: File,
  kind: 'request' | 'price',
): Promise<string | null> {
  const sizeMb = file.size / (1024 * 1024);
  if (sizeMb > MAX_UPLOAD_MB) {
    return `Файл «${file.name}» слишком большой (${sizeMb.toFixed(0)} МБ). Максимальный размер — ${MAX_UPLOAD_MB} МБ.`;
  }

  const name = file.name.toLowerCase();
  const isExcel = name.endsWith('.xlsx') || name.endsWith('.xls');

  if (kind === 'price') {
    if (!isExcel) {
      return `Прайс нужно загружать таблицей .xlsx или .xls (получен «${file.name}»).`;
    }
  } else if (!hasExtension(name, REQUEST_EXTENSIONS)) {
    return `Формат файла «${file.name}» не поддерживается. Пришлите Excel, CSV, PDF, Word или фотографию.`;
  }

  // Число строк проверяем только у таблиц; PDF, Word и фото проверит бэкенд
  if (!isExcel) return null;

  const maxRows = kind === 'price' ? MAX_PRICE_ROWS : MAX_REQUEST_ROWS;
  try {
    const buf = await file.arrayBuffer();
    // sheetRows ограничивает парсинг — не читаем весь файл в память
    const wb = XLSX.read(buf, { type: 'array', sheetRows: maxRows + 2, dense: true });
    let rows = 0;
    for (const sheetName of wb.SheetNames) {
      const ws = wb.Sheets[sheetName];
      const ref = ws && ws['!ref'];
      if (ref) {
        const range = XLSX.utils.decode_range(ref);
        rows += range.e.r - range.s.r + 1;
      }
    }
    if (rows > maxRows) {
      const shown = rows <= maxRows + 2 ? String(rows) : `${maxRows}+`;
      return `В таблице «${file.name}» слишком много строк (${shown}). Максимум — ${maxRows} строк. Разбейте файл на части.`;
    }
  } catch {
    // не смогли распарсить на клиенте — пропускаем, финальную проверку сделает бэкенд
  }
  return null;
}
